module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/225-maldives-fdf1755925cd1e4970a4548ed7073046.svg";